export enum ImAccessType {
    issuanceMonitor = 'IM',
    imDealsDealView = 'ImDealsDealView',
    imDealsClassView = 'ImDealsClassView',
    imDealsKMatrix = 'ImDealsKMatrix',
    imDashboard = 'ImDashboard',
    imArrangerPipeline= 'ImArrangerPipeline',
    imIoisDealView = 'ImIoisDealView',
    imIoisClassView = 'ImIoisClassView'
}
